import {
  Arbitrum,
  Avalanche,
  BASE,
  BNB,
  ETH,
  Optimism,
  Polygon,
  Rumble,
  Telegram,
  X,
  YouTube,
} from "@/icons";
import type { Chain, SocialMedium } from "@/types";

export const CHAINS: Chain[] = [
  {
    addresses: {
      treasuryPool: "0x5829543aaad6e5aa5e5633b61bfdfc037e4f8ece",
      xsd: "0x75cae30025a514b7ae069917e132cc99762a0e16",
    },
    Icon: ETH,
    id: BigInt(1),
    title: "ETH",
    token: "ETH",
    url: "https://ethereum-rpc.publicnode.com",
  },
  {
    addresses: {
      treasuryPool: "0x08f4f5a389a661d9f08c7514c73ac04dfd9d8ced",
      xsd: "0x39400e67820c88a9d67f4f9c1fbf86f3d688e9f6",
    },
    Icon: BNB,
    id: BigInt(56),
    title: "BNB",
    token: "BNB",
    url: "https://bsc-rpc.publicnode.com",
  },
  {
    addresses: {
      treasuryPool: "0x9bc6adf2569954a81f9eb8f99a14699fd11284e3",
      xsd: "0xa3034ef5f9d98f4dac6fc44421642c2616d9e346",
    },
    Icon: Arbitrum,
    id: BigInt(42161),
    title: "Arbitrum",
    token: "aETH",
    url: "https://arbitrum-one-rpc.publicnode.com",
  },
  {
    addresses: {
      treasuryPool: "0x30216ff7cdcf9c1c4997ed96d1ef134e29848d21",
      xsd: "0xabac1c04408cb6509bc9340e6b033c17f161ef9e",
    },
    Icon: Polygon,
    id: BigInt(137),
    title: "Polygon",
    token: "POL",
    url: "https://polygon-bor-rpc.publicnode.com",
  },
  {
    addresses: {
      treasuryPool: "0x0176c02a8991d8cafd6d514e73c26f32d0215a7b",
      xsd: "0x53f51fcdf06946aafe25f14d2f1c9b66e71ca683",
    },
    Icon: Optimism,
    id: BigInt(10),
    title: "Optimism",
    token: "oETH",
    url: "https://optimism-rpc.publicnode.com",
  },
  {
    addresses: {
      treasuryPool: "0x0176c02a8991d8cafd6d514e73c26f32d0215a7b",
      xsd: "0x93abe713002526d4ce708f890139f19313012f95",
    },
    Icon: BASE,
    id: BigInt(8453),
    title: "BASE",
    token: "bETH",
    url: "https://base-rpc.publicnode.com",
  },
  {
    addresses: {
      treasuryPool: "0x3a8a6f167f723403faa2e3c1c78c318927719a99",
      xsd: "0x93abe713002526d4ce708f890139f19313012f95",
    },
    Icon: Avalanche,
    id: BigInt(43114),
    title: "Avalanche",
    token: "AVAX",
    url: "https://avalanche-c-chain-rpc.publicnode.com",
  },
  /*
  {
    addresses: {
      treasuryPool: "",
      xsd: "",
    },
    Icon: Pulsechain,
    id: BigInt(369),
    title: "Pulsechain",
    token: "PLS",
    url: "wss://rpc.pulsechain.com",
  },
  */
];

export const GRAMS_PER_TROY_OUNCE = 31.1035;

export const LOCALE = "en-US";

export const SOCIAL_MEDIA: SocialMedium[] = [
  {
    Icon: Telegram,
    title: "Telegram",
    url: "https://t.me/BankXio",
  },
  {
    Icon: YouTube,
    title: "YouTube",
    url: "https://www.youtube.com/@BankXio?sub_confirmation=1",
  },
  {
    Icon: X,
    title: "X",
    url: "https://x.com/bankxio",
  },
  {
    Icon: Rumble,
    title: "Rumble",
    url: "https://rumble.com/c/BankXio",
  },
];

export const UNDEFINED_VALUE = "-";
